<template>
  <div class="art">
    <Header />
      <div class="bgTop" style="background-image: url('./img/BRAND STORY.png')">
      </div>
    <div class="art-main">
      <div class="main-content">
        <div v-html="content"></div>
        <!-- <div class="story">BRAND STORY</div>
        <div class="brand-name">品牌故事</div>
        <div class="content-info">
          伊维斯ENWEIS，2001酝酿于法国里昂，经与国际设计公司和优质面料供应商的协作， 2003年在中国诞生。国际化的视野和与众不同的艺术气质，为现代都市女性呈现出独具个人品味的视觉与身心体验，代表着对高品质生活的要求。
        </div>
        <div class="info-img">
          <img src="../../../assets/images/fb020e5eab6415ba2d5a4a7914ef825.png" alt="">
        </div>
        <div class="story">BRAND VALUE</div>
        <div class="brand-name">品牌价值</div>
        <div class="content-info">
          以“优雅、精致、诱惑”为品牌核心价值主张，致力于打造令女性具有优雅诱惑力的时尚品牌。专门开设内衣研究院，国际化的产品设计、专业研发的优质面料、体贴与呵护女性肌肤的产品、舒适人性化的购物环境、以客为本的服务标准……每一个细节都追求卓越与创新，致力于成为中国内衣行业优雅气质的倡导者。
        </div> -->
      </div>
    </div>
    <div class="code-bar">
    </div>
    <!-- 底部 -->
    <Concatc />
  </div>
</template>

<script>
import Header from '@/components/header/header';
import Concatc from '@/components/concatc/concatc';
import CONSTANT from '@/constant/constant.js';
import common from '@/common.js';
export default {
  components: {
    Header,
    Concatc
  },
  data(){
    return{
      content:''
    }
  },
  created(){
    this.getInfo();
  },
  methods:{
    // 获取插画列表
    getInfo(){
      let url = CONSTANT.ART.FINDVAL;
      common.postNoSess(url, null,null, res => {
        console.log(res);
        this.content = res.data.bussData;
      })
    },
  }
}
</script>

<style lang="less" scope>
  h1{
    padding-top:26px;
    // height:22px;
    font-size:34px;
    font-family:Georgia;
    font-weight:400;
    color:rgba(89,87,87,1);
  }
  .art{
    height: 100%;
  }
  .y-art-img{
    width: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .bgTop{
    width:100%;
    height:430px;
    background-size:contain;
  }
  .art-main{
    z-index: 10;
    width:100%;
    margin-right:20px;
    // height:1223px;
    margin-top:-212px;
    padding:0 30px 0 30px;
    .main-content{
      div{
        p{
          color: rgb(34, 34, 34);
          font-size:25px;
          font-family:SourceHanSansCN-Light;
          font-weight:300;
          // color:rgba(89,87,87,1);
          letter-spacing:2px;
          line-height: 46px;
          width: 100%;
          height: 100%;
          img{
          // margin-top: 63px;
            width: 100% !important;
            height: 100%;
          }
        }
      }
      padding:58px 38px;
      padding-bottom:0px;
      background: #f8f6f4;
      left:31px;
      top: 312px;
      .story{
        margin-top:76px;
        margin-bottom:24px;
        height:22px;
        font-size:29px;
        font-family:Georgia;
        font-weight:400;
        color:rgba(89,87,87,1);
      }
      .brand-name{
        height:28px;
        font-size:29px;
        font-family:SourceHanSansCN-Light;
        font-weight:300;
        color:rgba(89,87,87,1);
      }
      .content-info{
        margin-top:66px;
        font-size:25px;
        font-family:SourceHanSansCN-Light;
        font-weight:300;
        color:rgba(89,87,87,1);
        letter-spacing:3px;
        line-height: 40px;
      }
      .info-img{
        margin-top: 63px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .code-bar{
  margin:58px 0 65px;
  margin-left:355px;
  height:2px;
  background:rgba(89,87,87,1);
}

</style>
